import axios from 'axios';

export default {
  methods: {
    async getMaxAllowedVideos() {
      if (this.$store.getters.maxVideos !== -1) {
        const remainingVideo = await axios.get('remaining_videos');
        return remainingVideo.data.data.allowed_limit;
      }
      return 1;
    },

    async getRemainingPublishLimit() {
      if(this.$store.getters.maxPublishVideos == -1) {
        return Infinity;
      }

      // Get remaining number of videos that can be published
      const remainingVideos = await axios.get('remaining_publish_limit');

      if(remainingVideos.data.data && remainingVideos.data.data.allowed_limit) {
        return remainingVideos.data.data.allowed_limit;
      }

      return 0;
    },
  }
};